module.exports = __webpack_public_path__ + "static/media/butt07.d0848656.png";